import React from 'react';

import { Box, BoxProps } from '@mui/material';
import _ from 'es-toolkit/compat';

import { InfoBlockProvider } from 'src/providers/InfoBlockProvider';
import type { SxProp } from 'src/types/mui';
import { composeSx } from 'src/utils/styles';

type InfoBlockContainerProps = BoxProps & {
  loading?: boolean;
};

export const InfoBlockContainer: React.FC<React.PropsWithChildren<InfoBlockContainerProps>> = ({
  children,
  loading,
  ...boxProps
}) => {
  return (
    <InfoBlockProvider loading={loading}>
      <Box sx={composeSx(infoBlockContainerStyles, boxProps.sx)} {..._.omit(boxProps, 'sx')}>
        {children}
      </Box>
    </InfoBlockProvider>
  );
};

const infoBlockContainerStyles: SxProp = theme => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  columnGap: 8,
  rowGap: 1,
  justifyContent: 'start',
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'normal',
  },
});
